import { ErrorHandler, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { PagerBaseComponent } from '~/app/open-age/core/structures';
import { AppointmentsService } from '../services';
import { Appointment } from '../models/appointment.model';
import * as moment from 'moment-timezone';
import { UxService } from '~/app/core/services';
import { Organization } from '../models/organization.model';
import { AppointmentType } from '../models/appointment-type.model';
import { getTimezone, Timezone } from 'countries-and-timezones';

export class AppointmentListBaseComponent extends PagerBaseComponent<Appointment> implements OnInit, OnChanges, OnDestroy {

  @Input()
  readonly = false;

  @Input()
  sort = 'code';

  @Input()
  code: string;

  @Input()
  date: Date;

  @Input()
  from: Date;

  @Input()
  to: Date;

  @Input()
  agent: string;

  @Input()
  status: string;

  @Input()
  purpose: string;

  @Input()
  timeZone: string;

  @Input()
  organization: string;

  @Input()
  appointmentType: AppointmentType;

  @Input()
  visitor: string;

  constructor(
    private service: AppointmentsService,
    private errorHandler: UxService
  ) {
    super({
      api: service,
      errorHandler,
      filters: ['status', 'date', 'visitorName', 'agentName', 'purpose', 'from', 'to', 'sort', 'organization', 'appointmentType', 'timeZone'],
    });
  }

  ngOnInit() {
    this.search();
  }

  ngOnChanges(): void {
    this.search();
  }

  search() {
    this.filters.reset(false);
    if (this.code) {
      this.filters.set('code', this.code);
    }
    if (this.organization) {
      this.filters.set('organization', this.organization);
    }
    if (this.appointmentType) {
      this.filters.set('appointmentType', this.appointmentType.id);
    }
    if (this.purpose) {
      this.filters.set('purpose', this.purpose);
    }
    if (this.timeZone) {
      this.filters.set('timeZone', this.timeZone);
    }
    if (this.status) {
      this.filters.set('status', this.status);
      if (this.status == "expired") {
        this.filters.set('sort', "date-rev");
      }
    }
    if (this.date) {
      this.filters.set('date', moment(this.date).startOf('day').tz(this.timeZone).format());
    }
    if (this.from && this.to) {

      let timeZone = getTimezone(this.timeZone)

      let localOffset = moment().utcOffset()

      let utcOffset = timeZone.utcOffset

      if (moment.tz(this.from, timeZone.name).isDST()) {
        utcOffset = timeZone.dstOffset
      }

      utcOffset = (utcOffset * -1) + localOffset

      this.filters.set('from', moment(this.from).utcOffset(utcOffset).format("YYYY-MM-DDTHH:mm:ss"));
      this.filters.set('to', moment(this.to).utcOffset(utcOffset).format("YYYY-MM-DDTHH:mm:ss"));
    }
    if (this.agent && this.agent != '') {
      this.filters.set('agentName', this.agent);
    }
    if (this.visitor && this.visitor != '') {
      this.filters.set('visitorName', this.visitor);
    }
    // this.currentPageNo = 1;
    this.fetch();
  }

  ngOnDestroy(): void {
  }

  markVisited(item) {
    this.service.update(item.id, { status: "visited" }).subscribe(() => {
      this.errorHandler.handleError("Appointment Updated")
      this.search()
    })
  }

  getTime(date: Date) {
    return moment(date).tz(this.timeZone).format("h:mm a")
  }

  getDate(date: Date) {
    return moment(date).tz(this.timeZone).format("MM/DD/YYYY")
  }

}
